import React, { Fragment, useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadCourse } from "../../lib/api/course";
import { saveQuiz, save7Quiz } from "../../lib/api/quest";
import {
  DeatilInfoForm,
  DetailStudentForm,
  DetailQuestForm,
  DetailWeekForm,
} from "../../components/course/CourseDetailForm";
import { EmptyBlank } from "../../components/common";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [course, setCourse] = useState();

  const requestCourse = useCallback(async () => {
    const { course } = await loadCourse({ id });

    console.log( "course : ", course )

    setCourse(course);
  }, [id]);

  useEffect(() => {
    requestCourse();
  }, [id, requestCourse]);

  const handleEditWeek = (e) => {
    navigate(`../../weeks/${e.target.value}`);
  };

  const handleSaveQuiz = async (questID, content) => {
    const {status, quiz, message} = await saveQuiz(questID, content);
    
    if( status === 200){
      alert( `퀴즈가 저장 되었습니다.(저장 성공)` );
    }else{
      alert( `${message}` );
    }    
  }

  const handleSave7Quiz = async (questID, content) => {
    const {status, quiz, message} = await save7Quiz(questID, content)

    if( status === 200){
      alert( `퀴즈가 저장 되었습니다.(저장 성공)` );
    }else{
      alert( `${message}` );
    }
  }

  return (
    <section className="CourseDetail">
      <Container fluid="md">
        {course ? (
          <Fragment>
            <DeatilInfoForm info={course.info} />
            <DetailStudentForm students={course.students} />
            <DetailQuestForm 
              quests={course.quests} 
              professorID={course.professorId} 
              handleSaveQuiz={handleSaveQuiz}
              handleSave7Quiz={handleSave7Quiz}
            />
            <DetailWeekForm
              week={course.week12}
              handleEidtWeek={handleEditWeek}
            />
            <DetailWeekForm
              week={course.week13}
              handleEidtWeek={handleEditWeek}
            />
          </Fragment>
        ) : undefined}
        <EmptyBlank />
      </Container>
    </section>
  );
};

export default Detail;
